import gsap from 'gsap';
import { SIZES_COMMON } from '../../../constants/sizes';
import THREE from '../utils/threeClassesAdapter';

export class TwoNullsCameraRig {
    #camera;
    #isPortrait = false;
    #pointOfInterestInProgress = new THREE.Vector3(0, 0, 0);

    constructor(camera) {
        this.#camera = camera;
        this.pointOfInterest = new THREE.Vector3().copy(this.#pointOfInterestInProgress);
        this.position = new THREE.Vector3(0, 0, SIZES_COMMON.camDistance);
    }

    invalidate() {
        if (this.position) this.#camera.position.copy(this.position);
        if (this.pointOfInterest) this.#camera.lookAt(this.pointOfInterest);
        this.#camera.updateWorldMatrix(false, false);
    }

    set isPortrait(val) {
        this.#isPortrait = val;
        // this.gotoProgress(this.#progress);
    }

    get isPortrait() {
        return this.#isPortrait;
    }

    destroy() {
        gsap.killTweensOf(this.pointOfInterest);
        gsap.killTweensOf(this.position);
    }
}
